import { SyncShopifyProductsForTeamResponse } from "@redotech/redo-shopify-common/sync-shopify-products";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const syncShopifyProductsForTeam = {
  name: "syncShopifyProductsForTeam" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    response: createEnum(SyncShopifyProductsForTeamResponse),
  }),
};
